import React from "react";
// import "./Footer.css";

import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer-section">

      <div className="footer-circle"></div>

      <div className="container">

        <div className="row gy-5">

          {/* Logo */}

          <div className="col-lg-4">

            <img
              src="/images/logo-khult.png"
              alt="KhultStudios"
              className="footer-logo mb-4"
            />

            <p className="footer-text">
              KhultStudios is a professional photography studio specializing in
              Weddings, Fashion, Corporate, Product, Baby, Family and Creative
              Photography. We capture every moment beautifully.
            </p>

            <div className="footer-social">

              <a href="#">
                <FaFacebookF />
              </a>

              <a href="#">
                <FaYoutube />
              </a>

              <a href="#">
                <FaLinkedinIn />
              </a>

              <a href="#">
                <FaInstagram />
              </a>

            </div>

          </div>

          {/* Quick Links */}

          <div className="col-lg-3 col-md-6">

            <h4>Quick Links</h4>

            <ul>

              <li><a href="/">Home</a></li>

              <li><a href="/about-us">About Us</a></li>

              <li><a href="/image-gallery">Image Gallery</a></li>

              <li><a href="/video-gallery">Video Gallery</a></li>

              <li><a href="/career">Career</a></li>

              <li><a href="/contact-us">Contact Us</a></li>

            </ul>

          </div>

          {/* Photography Services */}

          <div className="col-lg-3 col-md-6">

            <h4>Photography Services</h4>

            <ul>

              <li><a href="/pre-wedding-and-wedding-photography">Pre Wedding & Wedding</a></li>

              <li><a href="/modelling-and-acting-photography">Modelling & Acting</a></li>

              <li><a href="/commercial-and-industrial-photography">Commercial & Industrial</a></li>

              <li><a href="/fashion-and-beauty-photography">Fashion & Beauty</a></li>

              <li><a href="/products-and-brands-photography">Products & Brands</a></li>

              <li><a href="/events-and-celebrations-photography">Events & Celebrations</a></li>

              <li><a href="/creative-and-arts-photography">Creative & Arts</a></li>

              <li><a href="/maternity-and-baby-photography">Maternity & Baby</a></li>

              <li><a href="/love-and-family-photography">Love & Family</a></li>

              <li><a href="/celebrity-and-movie-posters">Celebrity & Movie Posters</a></li>

            </ul>

          </div>

          {/* Contact */}

          <div className="col-lg-2">

            <h4>Contact Us</h4>

            <div className="contact-box">

              <div className="icon">
                <FaEnvelope />
              </div>

              <div>
                <span>Email</span>

                <p>info@khultstudios.com</p>
              </div>

            </div>

            <div className="contact-box">

              <div className="icon">
                <FaMapMarkerAlt />
              </div>

              <div>
                <span>Address</span>

                <p>Hyderabad, Telangana, India</p>
              </div>

            </div>

            <div className="contact-box">

              <div className="icon">
                <FaPhoneAlt />
              </div>

              <div>
                <span>Phone</span>

                <p>+91 98765 43210</p>
              </div>

            </div>

          </div>

        </div>

        <hr />

        <div className="copyright text-center">
          © {new Date().getFullYear()} KhultStudios. All Rights Reserved.
        </div>

      </div>

    </footer>
  );
};

export default Footer;